import WSJ_TARGETS, {
  FALLBACK_SIZE as WSJ_FALLBACK_SIZE,
  STYLES as WSJ_STYLES,
} from './targets-wsj';
import BARRONS_TARGETS, {
  FALLBACK_SIZE as BARRONS_FALLBACK_SIZE,
  STYLES as BARRONS_STYLES,
} from './targets-barrons';
import DJ_RISKJOURNAL_TARGETS, {
  FALLBACK_SIZE as DJ_RISKJOURNAL_FALLBACK_SIZE,
  STYLES as DJ_RISKJOURNAL_STYLES,
} from './targets-djriskjournal';
import FINANCIAL_NEWS_TARGETS, {
  FALLBACK_SIZE as FN_FALLBACK_SIZE,
  STYLES as FN_STYLES,
} from './targets-financialnews';
import MARKETWATCH_TARGETS, {
  FALLBACK_SIZE as MARKETWATCH_FALLBACK_SIZE,
  STYLES as MARKETWATCH_STYLES,
} from './targets-marketwatch';
import MANSION_GLOBAL_TARGETS, {
  FALLBACK_SIZE as MANSION_GLOBAL_FALLBACK_SIZE,
  STYLES as MANSION_GLOBAL_STYLES,
} from './targets-mansionglobal';

export function getTargets() {
  return [
    BARRONS_TARGETS,
    MANSION_GLOBAL_TARGETS,
    MARKETWATCH_TARGETS,
    FINANCIAL_NEWS_TARGETS,
    WSJ_TARGETS,
    DJ_RISKJOURNAL_TARGETS,
  ].filter((item) => {
    const property = window.location.pathname.split('/')[1];
    return property && property.indexOf(item.value) !== -1;
  });
}

export function getTargetTitle(id) {
  return getTargetProp(id, 'title');
}

export function getTargetProp(id, prop) {
  const TARGETS = getTargets();
  if (typeof id === 'string') {
    id = id.indexOf('wsj') === 0 ? 'wsj' : id;
    for (let t = 0; t < TARGETS.length; t++) {
      if (TARGETS[t].value === id) {
        return TARGETS[t][prop];
      }
    }
  }
  return null;
}

export function getSizesForTarget(target) {
  return getTargetProp(target, 'sizes');
}

export function getPossibleGroups(target) {
  const sizes = getSizesForTarget(target);
  if (sizes) {
    const groups = [];
    sizes.forEach((size) => {
      if (groups.indexOf(size.group) === -1) {
        groups.push(size.group);
      }
    });
    return groups;
  }
  return null;
}

export function getDefaultGroups(target) {
  const defGroups = getTargetProp(target, 'defaultGroups');
  if (defGroups) {
    return defGroups;
  }
  return getPossibleGroups(target);
}

export function getSizeById(id, sizes) {
  if (sizes) {
    for (let s = 0; s < sizes.length; s++) {
      if (sizes[s].id === id) {
        return sizes[s];
      }
    }
  }
  const TARGETS = getTargets();
  for (let t = 0; t < TARGETS.length; t++) {
    for (let s = 0; s < TARGETS[t].sizes.length; s++) {
      if (TARGETS[t].sizes[s].id === id) {
        return TARGETS[t].sizes[s];
      }
    }
  }
  return null;
}

export const getFallbackSize = (publication) => {
  switch (publication) {
    case 'barrons':
      return BARRONS_FALLBACK_SIZE;
    case 'djriskjournal':
      return DJ_RISKJOURNAL_FALLBACK_SIZE;
    case 'marketwatch':
      return MARKETWATCH_FALLBACK_SIZE;
    case 'fnlondon':
      return FN_FALLBACK_SIZE;
    case 'mansionglobal':
      return MANSION_GLOBAL_FALLBACK_SIZE;
    default:
      return WSJ_FALLBACK_SIZE;
  }
};

const getStylesUrl = (publication = 'wsj', chartCssPath) =>
  `\n@import url("${
    publication === 'wsj' ? window.DYNAMIC_INSET_ENDPOINT_WSJ : window.DYNAMIC_INSET_ENDPOINT_DJMG
  }/dynamic-insets/charts/${chartCssPath}");`;

const getFontStyles = (publication) => {
  switch (publication) {
    case 'barrons':
      return BARRONS_STYLES;
    case 'djriskjournal':
      return DJ_RISKJOURNAL_STYLES;
    case 'mansionglobal':
      return MANSION_GLOBAL_STYLES;
    case 'fnlondon':
      return FN_STYLES;
    case 'marketwatch':
      return MARKETWATCH_STYLES;
    default:
      return WSJ_STYLES;
  }
};

export const getAllStyles = (product, chartCssPath) =>
  `${getStylesUrl(product, chartCssPath)}${getFontStyles(product)}`;
